/*
 * File: common.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-30 5:27:43 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

// 公共组件
import fetch from '../fetch';

import {
  DICT_SELECT_LIST,
  MENU_DICTIONARY_LIST,
  GET_AREA_LIST,
  GET_BUY_PLAT_FORM,
  GET_PRODUCT_TYPE,
  SUPPORT_GET_BRAND,
  GET_PRODUCT_SUB_TYPE,
  GET_CSS_PRODUCT_TYPE,
  AUTH_GET_BRAND,
  GET_POINT_GROW_LIST,
  UPLOAD_IMG_DIRECT_TO_OSS_URL,
  DICT_ITEM_LIST_URL,
  DICT_SCREEN_ITEM_LIST_URL,
  GET_SDAPP_VERSION,
  // 获取秘钥vcode
  GET_VCODE,
  // 获取当前服务器时间
  GET_SYSTEM_TIME,
  // 一次性获取所有的省市区
  AREA_SELECT_EXCEPT_STREET,
  GET_WXCHAT_LIST,
  // 公告
  NOTICE_SELECT_NOTICE_LIST,
  NOTICE_INSET_OR_UPDATE_NOTICE,
  NOTICE_CHANGE_NOTICE_ENABLED,
} from '../url';

// 推送管理请求header
const headers = {
  'Content-Type': 'application/json',
};

/**
 * 数据字典
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dictSelectList(data) {
  let arr = [];
  return fetch({
    url: DICT_SELECT_LIST,
    method: 'get',
    params: data,
    isNoMsg: true
  }).then(res => {
    if (res.code === 0) {
      // 只返回已启用的数据
      if (res.data && res.data.length) {
        res.data.forEach(item => {
          if (item.enabled) {
            arr.push(item);
          }
        });
      }
      res.data = arr;
      return res;
    } else {
      return res;
    }
  });
};

/**
 * 数据字典
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function menuDictionaryList(data) {
  return fetch({
    url: MENU_DICTIONARY_LIST,
    method: 'get',
    params: data,
  });
};

/**
 * 获取城市列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAreaList(data) {
  return fetch({
    url: GET_AREA_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 购买订单平台
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBuyPlatForm(data) {
  return fetch({
    url: GET_BUY_PLAT_FORM,
    method: 'GET',
    params: data
  });
};

/**
 * 获取购买商品品类 大类
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductType(data) {
  return fetch({
    url: GET_PRODUCT_TYPE,
    method: 'GET',
    params: data
  });
};

/**
 * 获取购买商品品类 小类
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getProductSubType(data) {
  return fetch({
    url: GET_PRODUCT_SUB_TYPE,
    method: 'GET',
    params: data
  });
};

/**
 * 家电等级 获取品牌
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBankds(data) {
  return fetch({
    url: SUPPORT_GET_BRAND,
    method: 'GET',
    params: data
  });
};

/**
 * 家电登记 大类 小类获取
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCssProductType(data) {
  return fetch({
    url: GET_CSS_PRODUCT_TYPE,
    method: 'GET',
    params: data
  });
};

/**
 * 获取品牌权限列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAuthBrand(data) {
  return fetch({
    url: AUTH_GET_BRAND,
    method: 'GET',
    params: data,
    isNoMsg: true
  });
};

/**
 * 获取成长管理、积分管理级联列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointGrowKeyList(data) {
  return fetch({
    url: GET_POINT_GROW_LIST,
    method: 'POST',
    data: data
  });
};

/**
 * 上传图片，直接上传oss
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function directUploadToOss(data) {
  return fetch({
    url: UPLOAD_IMG_DIRECT_TO_OSS_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
};
/**
 * 获取数据字典方法 2020.10.29
 * @param {Record<'code', string>[]} params
 */
async function getDictList(params) {
  const res = await fetch.post(DICT_ITEM_LIST_URL, params);
  if (res.code === '0000') {
    const { data } = res[0];
    return data;
  } else return res;
}

/**
 * 获取推送页面下拉框 字典
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dictItemList(requestData) {
  return fetch({
    url: DICT_ITEM_LIST_URL,
    method: 'post',
    data: requestData,
    headers: headers
  }).then(res => {
    if (res.code === '0000') {
      // 只返回已启用的数据
      if (res.data && res.data.length) {
        res.data.forEach(item => {
          item.data = item.data.filter(child => {
            return child.enabled;
          });
        });
      }
      return res;
    } else {
      return res;
    }
  });
};
function dictScreenItemList(requestData) {
  return fetch({
    url: DICT_SCREEN_ITEM_LIST_URL,
    method: 'post',
    params: requestData,
    headers: headers,
    testerUrl: '/test/'
  });
};
// 获取秘钥vcode
function getVcode(requestData) {
  return fetch({
    url: GET_VCODE,
    method: 'post',
    params: requestData,
    headers: headers
  });
};

// 获取省电app版本
function getSdappVersion(requestData) {
  return fetch({
    url: GET_SDAPP_VERSION,
    method: 'post',
    params: requestData,
    headers: headers
  });
};

/**
 * 获取当前服务器时间
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSystemTime(data) {
  return fetch({
    url: GET_SYSTEM_TIME,
    method: 'get',
    params: data
  });
};

// 一次性获取所有的省市区
function selectExceptStreet(data) {
  return fetch({
    url: AREA_SELECT_EXCEPT_STREET,
    method: 'post',
    data: data
  });
};

/**
 * 获取微信公众号列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getWeChatList(data) {
  return fetch({
    url: GET_WXCHAT_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 获取公告列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectNoticeList(data) {
  return fetch({
    url: NOTICE_SELECT_NOTICE_LIST,
    method: 'POST',
    data: data
  });
};

/**
 * 新增修改公告
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateNotice(data) {
  return fetch({
    url: NOTICE_INSET_OR_UPDATE_NOTICE,
    method: 'POST',
    data: data
  });
};

/**
 * 公告的开启和禁用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function changeNoticeEnabled(data) {
  return fetch({
    url: NOTICE_CHANGE_NOTICE_ENABLED,
    method: 'POST',
    data: data
  });
};

const common = {
  getSdappVersion,
  dictSelectList,
  menuDictionaryList,
  getAreaList,
  getBuyPlatForm,
  getProductType,
  getProductSubType,
  getBankds,
  getCssProductType,
  getAuthBrand,
  getPointGrowKeyList,
  directUploadToOss,
  dictItemList,
  getDictList,
  dictScreenItemList,
  getVcode,
  // 获取当前服务器时间
  getSystemTime,
  // 一次性获取所有的省市区
  selectExceptStreet,
  getWeChatList,
  // 公告
  selectNoticeList,
  insertOrUpdateNotice,
  changeNoticeEnabled,
};

export { common };
